export default __webpack_public_path__ + "media/zurb/img/ecommerce/esv-fe94e75e5e59bd299a20a62d5a7c50d2.png";